import { jsx, jsxs } from "react/jsx-runtime";
import { getConfig } from "@tamagui/core";
import { useState } from "react";
import { Button, H2, H3, H4, Separator, Square, XGroup, XStack, YStack } from "tamagui";
const sections = [
  {
    name: `Size`,
    key: `size`
  },
  {
    name: `Space`,
    key: "space"
  },
  {
    name: `Space (-)`,
    key: `spaceNegative`
  },
  {
    name: `Radius`,
    key: `radius`
  }
];
function TokensDemo() {
  const [section, setSection] = useState("size");
  return /* @__PURE__ */ jsxs(YStack, { space: true, children: [
    /* @__PURE__ */ jsx(XGroup, { alignItems: "center", alignSelf: "center", children: sections.map(({ name, key }) => {
      return /* @__PURE__ */ jsx(XGroup.Item, { children: /* @__PURE__ */ jsx(
        Button,
        {
          size: "$3",
          theme: section === key ? "active" : null,
          fontFamily: "$silkscreen",
          onPress: () => setSection(key),
          children: name
        }
      ) }, key);
    }) }),
    (section === "size" || section === "spaceNegative" || section === "space" || section === "radius") && /* @__PURE__ */ jsx(SizeSection, { section })
  ] });
}
function SizeSection({ section }) {
  const allTokens = getConfig().tokens;
  const tokens = allTokens[section.startsWith("space") ? "space" : section];
  const st = Object.keys(tokens).sort((a, b) => parseFloat(a) > parseFloat(b) ? 1 : -1);
  const spaceTokens = st.filter((t) => parseFloat(t) >= 0);
  const spaceTokensNegative = st.filter((t) => parseFloat(t) < 0).sort((a, b) => parseFloat(a) > parseFloat(b) ? -1 : 1);
  return /* @__PURE__ */ jsxs(YStack, { flex: 1, space: true, children: [
    /* @__PURE__ */ jsx(H2, { children: "Sizes" }),
    /* @__PURE__ */ jsx(YStack, { width: "100%", space: "$2", separator: /* @__PURE__ */ jsx(Separator, {}), children: (section === "spaceNegative" ? spaceTokensNegative : spaceTokens).map(
      (token) => {
        var _a, _b, _c, _d, _e;
        return /* @__PURE__ */ jsxs(XStack, { width: "100%", alignItems: "center", children: [
          /* @__PURE__ */ jsx(YStack, { width: "25%", children: /* @__PURE__ */ jsxs(H3, { size: "$6", children: [
            "$",
            token
          ] }) }),
          /* @__PURE__ */ jsx(YStack, { width: "20%", children: /* @__PURE__ */ jsxs(H4, { size: "$5", children: [
            (_a = tokens[token]) == null ? void 0 : _a.val,
            "px"
          ] }) }),
          /* @__PURE__ */ jsx(
            Square,
            {
              size: (_b = tokens[token]) == null ? void 0 : _b.val,
              backgroundColor: "$color5",
              ...section === "spaceNegative" && {
                backgroundColor: "$red5",
                size: -((_c = tokens[spaceTokensNegative.find(
                  (t) => parseFloat(t) === -parseFloat(token)
                ) ?? token]) == null ? void 0 : _c.val)
              },
              ...section === "radius" && {
                // @ts-ignore
                size: (_d = allTokens.size[token]) == null ? void 0 : _d.val,
                borderRadius: (_e = tokens[token]) == null ? void 0 : _e.val
              }
            }
          )
        ] }, token);
      }
    ) })
  ] });
}
export {
  TokensDemo
};
//# sourceMappingURL=TokensDemo.js.map
